import React from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import ManagedTextArea from "utils/edit/ManagedTextArea";

import { TextField } from "../FieldService";
import {
	InformationRight,
	ReportFieldRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";

export type TextInputProps = {
	field: TextField;
	rights: ReportFieldRights;
	editable: boolean;
	onChange: (uuid: string, value: string) => void;
};

const TextInput: React.FC<TextInputProps> = (props: TextInputProps) => {
	function toId(uuid: string): string {
		const separatorIndex = uuid.indexOf("#");
		return separatorIndex === -1 ? uuid : uuid.substring(0, separatorIndex);
	}

	return (
		<Grid item>
			<Typography>{props.field.name}</Typography>
			<ManagedTextArea
				fullWidth
				minRows={4}
				disabled={
					!props.editable ||
					props.rights[toId(props.field.uuid)][
						InformationRight.WRITE
					] === false
				}
				value={props.field.value}
				onUpdate={value => props.onChange(props.field.uuid, value)}
			/>
		</Grid>
	);
};

export default TextInput;
